import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import en from "assets/language/en.json";
import cn from "assets/language/cn.json";
import id from "assets/language/id.json";
import my from "assets/language/my.json";
import ph from "assets/language/ph.json";
import th from "assets/language/th.json";
import vi from "assets/language/vi.json";

import logoChi from "./component/Helpers/icons/flag/flagChina.svg";
import logoUSA from "./component/Helpers/icons/flag/flagUSA.svg";
import logoId from "./component/Helpers/icons/flag/flagID.svg";
import logoMy from "./component/Helpers/icons/flag/flagMY.svg";
import logoPh from "./component/Helpers/icons/flag/flagPH.svg";
import logoTh from "./component/Helpers/icons/flag/flagTH.svg";
import logoVi from "./component/Helpers/icons/flag/flagVN.svg";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "En",
    resources: {
      En: {
        translation: en,
        logo: logoUSA,
      },
      Chi: {
        translation: cn,
        logo: logoChi,
      },
      Id: {
        translation: id,
        logo: logoId,
      },
      My: {
        translation: my,
        logo: logoMy,
      },
      Ph: {
        translation: ph,
        logo: logoPh,
      },
      Th: {
        translation: th,
        logo: logoTh,
      },
      Vi: {
        translation: vi,
        logo: logoVi,
      },
    },
  });

export default i18n;
